import React from 'react';
import logo from '../../assets/images/logonova-escuro.png';

function Header() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container">
        <a className="navbar-brand" href="#hero">
          <img
            src={logo}
            alt="Logo da Igreja"
            width={150}
            className="d-inline-block align-text-top"
          />
        </a>

        {/* Botao de Menu para Mobile */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Links de Navegacao */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto fw-semibold">
            <li className="nav-item">
              <a className="nav-link" href="#hero">Home</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#sobre">Sobre</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#agenda">Agenda</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#doacoes">Doacoes</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#espaco-da-palavra">Palavra</a>
            </li>
            {/* <li className="nav-item">
              <a className="nav-link evento-link" href="#evento">
                <i className="bi bi-stars me-1"></i>3o Aniversario
              </a>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Header;
